module.exports = __webpack_public_path__ + "3c8c567a008c1066e2a48e0ebe0e46c4.svg";